import { useState } from "react";
import { getApp } from "../../../store/slices/app.slice";
import { useSelector } from "react-redux";

import APP_CONSTANT from "../../../constants/index.constant";
import useTranslation from "../../../utils/useTranslation";
import enhanceRecommendation from "../../../constants/enhance-recommendation.constant";
import lensesLeftWhite from "../../../assets/svg/lenses-left-white.svg";
import correctRecommendation from "../../../constants/correct-recommendation.constant";
import RestartIcon from "../../../components/ui/RestartIcon";

const AdditionalPairCard = ({
  item,
  correctReco,
  protectReco,
  enhanceReco,
}: any) => {
  const { theme } = useSelector(getApp);
  const { t } = useTranslation(useSelector(getApp));
  const [openAdditionalPackage, setOpenAdditionalPackage] =
    useState<boolean>(false);
  const [selectedAnswers, setSelectedAnswers] = useState([
    {
      id: 1,
      answer: { id: -1, point: -1, answer: "" },
    },
    {
      id: 2,
      answer: { id: -1, point: -1, answer: "" },
    },
    {
      id: 3,
      answer: { id: -1, point: -1, answer: "" },
    },
  ]);
  const [recommendation, setRecommendation] = useState<any>({
    correctReco: {},
    enhance: {},
    protectReco: {},
  });
  const [seeResult, setSeeResult] = useState<boolean>(false);
  const [cardScreen, setCardScreen] = useState<
    "default" | "questionnaire" | "recommendation"
  >("default");

  const dedicatedIndoorPairQuestionnaires = [
    {
      id: 1,
      question: "qstn_how_many_hours_working_close",
      choices: [
        {
          id: 1.1,
          point: 1,
          answer: "qstn_answer_below_2h",
        },
        {
          id: 1.2,
          point: 2,
          answer: "qstn_answer_2h_to_4h",
        },
        {
          id: 1.3,
          point: 3,
          answer: "qstn_answer_4h_more",
        },
      ],
    },
    {
      id: 2,
      question: "qstn_fatigue_after_hours_working",
      choices: [
        {
          id: 2.1,
          point: 1,
          answer: "qstn_answer_below_2h",
        },
        {
          id: 2.2,
          point: 2,
          answer: "qstn_answer_2h_to_4h",
        },
        {
          id: 2.3,
          point: 3,
          answer: "qstn_answer_4h_more",
        },
      ],
    },
    {
      id: 3,
      question: "qstn_need_extra_visual_support",
      choices: [
        {
          id: 3.1,
          point: 1,
          answer: "qstn_answer_below_2h",
        },
        {
          id: 3.2,
          point: 2,
          answer: "qstn_answer_2h_to_4h",
        },
        {
          id: 3.3,
          point: 3,
          answer: "qstn_answer_4h_more",
        },
      ],
    },
  ];

  const handleChoiceClick = (questionId: number, selected: any) => {
    const tempData = selectedAnswers.map((temp) => {
      if (temp.id === questionId) {
        return {
          ...temp,
          answer: selected,
        };
      }
      return temp;
    });
    setSelectedAnswers(tempData);
  };

  const handleRestart = () => {
    setCardScreen("default");
    setRecommendation({
      correctReco: {},
      enhance: {},
      protectReco: {},
    });
    setSelectedAnswers([
      {
        id: 1,
        answer: { id: -1, point: -1, answer: "" },
      },
      {
        id: 2,
        answer: { id: -1, point: -1, answer: "" },
      },
      {
        id: 3,
        answer: { id: -1, point: -1, answer: "" },
      },
    ]);
  };

  const handleRecommendation = () => {
    /*
     Logic: UI will be the same as Package Offer Card
     1. Correct Reco - base on answer -> OfficeVision Product Logic
     2. Protect Reco - Either Transitions || Bluecut
     3. Enhance Reco - if Branded -> Crizal || if Unbranded -> PAR OR SAR 
    */
    const cR: any = correctRecommendation;
    let mainRecom = { lensType: APP_CONSTANT.CORRECT, name: "NO RECO" };

    if (selectedAnswers[0].answer.point === selectedAnswers[1].answer.point && selectedAnswers[0].answer.point === selectedAnswers[2].answer.point) {
      mainRecom = cR[APP_CONSTANT.PAL][9];
    } else {
      if (selectedAnswers[0].answer.point === 3) {
        // Question 1
        mainRecom = cR[APP_CONSTANT.PAL][7];
      } else {
        if (selectedAnswers[1].answer.point === 3) {
          // Question 2
          mainRecom = cR[APP_CONSTANT.PAL][8];
        } else {
          if (selectedAnswers[2]) {
            // Question 3
            mainRecom = cR[APP_CONSTANT.PAL][9];
          }
        }
      }
    }

    setRecommendation((prev: any) => {
      return {
        ...prev,
        correctReco: mainRecom,
        protectReco: protectReco,
        enhance: correctReco.branded
          ? enhanceRecommendation.PAL[3] // If correct === branded => PAR
          : enhanceReco,
      };
    });
  };

  let enableSeeResult = selectedAnswers.every((i) =>
    i.answer.answer === "" ? false : true
  );

  return (
    <div className="additional-pair-card">
      {item.title === "pair_card_title_indoor_pair" ? (
        <>
          {cardScreen === "default" && (
            <>
              <img
                className="additional-pair-card-image"
                src={item?.image?.[theme]}
                alt={t(item?.title)}
              />
              <div className={`badge badge-${theme}`}>
                <div className="dot"></div>
                <span>
                  {t(
                    item?.type === APP_CONSTANT.HIGH
                      ? "badge_highly_recommended"
                      : "badge_recommended"
                  )}
                </span>
              </div>
              {item.title === "pair_card_title_indoor_pair" && (
                <button
                  className="create-package-btn bold"
                  onClick={() => setCardScreen("questionnaire")}
                >
                  Create Package
                </button>
              )}
              <div className="additional-pair-info-container">
                <h2 className={`title-font recom-title-${theme}`}>
                  {t(item?.title)}
                </h2>
                <p className={`recom-paragraph-${theme}`}>{t(item?.text)}</p>
              </div>
            </>
          )}

          {/* Additional Package Questionnaire */}
          {cardScreen === "questionnaire" && (
            <div className="additional-package-container">
              <div>
                <h1 className={`title-font recom-title-${theme}`}>
                  {t("title_dedicated_indoor_pair")}
                </h1>
                <h3 className={`title-font recom-title-${theme}`}>
                  {t("subtitle_lifestyle_advisory_questionnaire")}
                </h3>
                <p className={`recom-paragraph-${theme}`}>
                  {t("answer_some_of_qstn")}
                </p>
              </div>
              {/* Questionnaires for Dedicated indoor pair */}
              <ul>
                {dedicatedIndoorPairQuestionnaires.map(
                  ({ id, question, choices }, index) => (
                    <li key={index}>
                      <p className={`recom-paragraph-${theme}`}>
                        {t(question)}
                      </p>
                      <div className="additional-package-radio-container">
                        {choices.map((c, index) => (
                          <div
                            key={index}
                            className="additional-package-radio-button"
                            onClick={() => handleChoiceClick(id, c)}
                          >
                            <div className="radio-btn-outer">
                              {selectedAnswers.map((ans, index) =>
                                ans.answer.id === c.id ? (
                                  <div
                                    key={index}
                                    className="radio-btn-inner"
                                  ></div>
                                ) : null
                              )}
                            </div>
                            <span>{t(c.answer)}</span>
                          </div>
                        ))}
                      </div>
                    </li>
                  )
                )}
              </ul>

              <button
                onClick={() => {
                  handleRecommendation();
                  setCardScreen("recommendation");
                }}
                style={{
                  pointerEvents: !enableSeeResult ? "none" : "all",
                  opacity: !enableSeeResult ? ".50" : "1",
                }}
              >
                {t("see_result")}
              </button>
            </div>
          )}

          {/* Additional Pair Card Recommendation */}
          {cardScreen === "recommendation" && (
            <>
              <img
                className="additional-pair-card-image"
                src={item?.image?.[theme]}
                alt={t(item?.title)}
              />
              <div className={`badge badge-${theme}`}>
                <div className="dot"></div>
                <span>
                  {t(
                    item?.type === APP_CONSTANT.HIGH
                      ? "badge_highly_recommended"
                      : "badge_recommended"
                  )}
                </span>
              </div>

              <div className="additional-pair-recom-container">
                <div className="product-name-container">
                  <h3 className={`recom-title-${theme}`}>
                    {t(recommendation.correctReco.display.general.name)}
                  </h3>
                </div>
                <ul className="recommendation-container">
                  <li className="recom-item-list">
                    <img src={lensesLeftWhite} alt="lenses" />
                    <span className={`span-item-${theme}`}>
                      {t(recommendation.correctReco.display.general.name)}
                    </span>
                  </li>
                  <li className="recom-item-list">
                    <img src={lensesLeftWhite} alt="lenses" />
                    <span className={`span-item-${theme}`}>
                      {t(recommendation.protectReco.display.general.name)}
                    </span>
                  </li>
                  <li className="recom-item-list">
                    <img src={lensesLeftWhite} alt="lenses" />
                    <span className={`span-item-${theme}`}>
                      {t(recommendation.enhance.display.general.name)}
                    </span>
                  </li>
                  <button
                    className={`restart-button btn bold small next-qst-btn-${theme} next-qst-btn-${theme}`}
                    onClick={handleRestart}
                  >
                    <span>{t("btn_restart")}</span>
                    {/* <RestartIcon /> */}
                  </button>
                </ul>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <img
            className="additional-pair-card-image"
            src={item?.image?.[theme]}
            alt={t(item?.title)}
          />
          <div className={`badge badge-${theme}`}>
            <div className="dot"></div>
            <span>
              {t(
                item?.type === APP_CONSTANT.HIGH
                  ? "badge_highly_recommended"
                  : "badge_recommended"
              )}
            </span>
          </div>
          {item.title === "pair_card_title_indoor_pair" && (
            <button
              className="create-package-btn bold"
              onClick={() => setOpenAdditionalPackage(true)}
            >
              {t("create_package")}
            </button>
          )}
          <div className="additional-pair-info-container">
            <h2 className={`title-font recom-title-${theme}`}>
              {t(item?.title)}
            </h2>
            <p className={`recom-paragraph-${theme}`}>{t(item?.text)}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default AdditionalPairCard;
